import { render } from "./header.vue?vue&type=template&id=8af5bdee&scoped=true"
import script from "./header.vue?vue&type=script&lang=ts"
export * from "./header.vue?vue&type=script&lang=ts"

import "./header.vue?vue&type=style&index=0&id=8af5bdee&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8af5bdee"

export default script